export enum USERS_INVITATIONS_DIALOGS {
  CancelInvitation = "cancel invitation",
  ResendInvitation = "resend invitation",
}
